export const UPDATE_ASSEMBLED_DOCUMENTS = 'UPDATE_ASSEMBLED_DOCUMENTS';

export const updateAssembledDocuments = data => ({
  type: UPDATE_ASSEMBLED_DOCUMENTS,
  data,
});
